import { uiEvents } from '@/utils/event'
import { useMenuDesignTheme } from '@/services/menu-design'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { ReactNode } from 'react'

/**
 * Флажок гостевых форм: согласие на обработку данных, бронь стола, сообщение.
 *
 * На витрине этот компонент живёт вне темы MUI панели, поэтому получал
 * заводские иконки — синий квадрат с белой птичкой. Флажок темы выглядит
 * иначе: скруглённый квадрат, в выключенном виде — светлый квадрат с заметной
 * обводкой (серая обводка цвета линии на сером фоне не читалась), во включённом
 * лаймовая заливка с чернильной птичкой. Так нарисован флажок «Принести счет»
 * на витрине и флажок в панели — рисуем его и здесь, чтобы во всех формах
 * флажок был один и тот же.
 */
function ThemeBoxIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <rect
        x="1.1"
        y="1.1"
        width="21.8"
        height="21.8"
        rx="7"
        fill="var(--back)"
        stroke="var(--ink-3)"
        strokeWidth="1.6"
      />
    </svg>
  )
}

function ThemeCheckIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <rect x="0.3" y="0.3" width="23.4" height="23.4" rx="7" fill="var(--action)" />
      <path
        d="M6.6 12.4l3.4 3.4 7-7.2"
        fill="none"
        stroke="var(--action-ink)"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MuiCheckbox(props: {
  id: string
  label: ReactNode
  value: boolean
  checkboxProps?: CheckboxProps
  disabled?: boolean
}) {
  const theme = useMenuDesignTheme()
  // в панели свой набор иконок задан темой MUI — там ничего не подменяем
  const themeIcons =
    theme === 'modern' ? { icon: <ThemeBoxIcon />, checkedIcon: <ThemeCheckIcon /> } : {}

  return (
    <FormControlLabel
      onChange={() => {
        uiEvents.next({
          type: 'CheckboxToggle',
          id: props.id,
        })
      }}
      control={
        <Checkbox
          {...themeIcons}
          {...props.checkboxProps}
          disabled={props.disabled}
          checked={props.value}
        />
      }
      label={props.label}
    />
  )
}
